<script setup>
import { computed, onMounted, ref, watch } from "vue";
import {
  Icon,
  Tabs,
  Tab,
  Input,
  Label,
  Textarea,
  Select,
  MediaUploaderButton,
  Toggle,
  ColorPickerDefault,
} from "@components";
import { regex } from "@utils";

import { useRouter, useRoute } from "vue-router";
const router = useRouter();
const route = useRoute();

import { useSettings } from "@store/settings";
const $settings = useSettings();

const useColorPalette = () => {
  const showAddNewColor = ref(false);

  const isValid = ref(false);

  const newColor = ref("");

  const addNewColor = () => {
    $settings.customizer.sidebar.background_colors.push(newColor.value);
    newColor.value = "";
    showAddNewColor.value = false;
    isValid.value = false;
  };

  watch(newColor, () => {
    isValid.value = false;

    // check code length with #
    if (newColor.value.length !== 7)
      return console.log("Must be 7 characters with #");

    // check duplicate
    if (
      $settings.customizer.sidebar.background_colors.includes(
        String(newColor.value).toUpperCase()
      )
    )
      return console.log("Duplicate color");

    // check color code
    if (!regex.hexCode.test(newColor.value))
      return console.log("Invalid color code");

    isValid.value = true;
  });

  return { showAddNewColor, addNewColor, newColor, isValid };
};

const { showAddNewColor, addNewColor, newColor, isValid } = useColorPalette();

const positions = ref([
  {
    label: "Left bottom",
    value: "Left bottom",
    icon: "leftBottom",
  },
  {
    label: "Left top",
    value: "Left top",
    icon: "leftTop",
  },
  {
    label: "Right bottom",
    value: "Right bottom",
    icon: "rightBottom",
  },
  {
    label: "Right top",
    value: "Right top",
    icon: "rightTop",
  },
]);

const changePosition = (value) => {
  $settings.settings.chat_widget.customizer.settings.button_position = value;
};

onMounted(() => {
  // prebook_admin.settings.customizer.sidebar['show_background'] = false
  // prebook_admin.settings.customizer.sidebar['background_type'] = 'color'
  // prebook_admin.settings.customizer.sidebar['background_color'] = '#FFFEFE'
  // prebook_admin.settings.customizer.sidebar['background_colors'] = colors.value
  // prebook_admin.settings.customizer.sidebar['background_image'] = ''
  // prebook_admin.settings.customizer.sidebar['content_position'] = 'Left top'
  // if ($settings.customizer.sidebar.show_background) {
  //     router.push({
  //         query: {
  //             ...route.query,
  //             background: $settings.customizer.sidebar.background_type || 'image'
  //         }
  //     })
  // }
});

const positionIcon = computed(() => {
  switch ($settings.settings.chat_widget.customizer.settings.button_position) {
    case "Left bottom":
      return "leftBottom";
    case "Left top":
      return "leftTop";
    case "Right bottom":
      return "rightBottom";
    case "Right top":
      return "rightTop";
  }
});

const logo = computed(() => {
  if ($settings.customizer.sidebar.business_custom_logo !== "")
    return $settings.customizer.sidebar.business_custom_logo;

  return $settings.business.full_logo_url;
});

// const businessName = computed(() => {
//     return $settings.business.name
// })

const setbackgroundType = (value) => {
  $settings.customizer.sidebar.background_type =
    String(value).toLocaleLowerCase();
};
</script>

<template>
  <div>
    <div>
      <div
        class="text-[#344054] font-medium text-sm flex justify-between items-center"
      >
        Widget default view
        <Toggle
          v-model="
            $settings.settings.chat_widget.customizer.settings.widget_view
          "
        ></Toggle>
      </div>
      <p class="text-[#667085] text-xs mt-2">
        If you want to show the widget without clicking the button, please
        enable this option.
      </p>
    </div>
    <div class="h-[1px] w-full my-3"></div>
    <div>
      <div>
        <div class="flex gap-1 justify-between">
          <div class="text-[#344054] font-medium text-sm">
            Button Text
            <div class="text-[#D92D20] inline-block">*</div>
          </div>
        </div>

        <Input
          required
          v-model="
            $settings.settings.chat_widget.customizer.settings.button_text
          "
          type="text"
          size="sm"
          class="mt-1.5"
          inputClass="text-base"
        ></Input>
      </div>
    </div>

    <div class="h-[1px] w-full my-3"></div>

    <div>
      <div class="text-[#344054] font-medium text-sm">Button Position</div>
      <Select
        :iconLeft="positionIcon"
        iconLeftClass="text-[#7F56D9] w-6"
        v-model="
          $settings.settings.chat_widget.customizer.settings.button_position
        "
        :options="positions"
        @change="(value) => changePosition(value)"
        class="my-1.5"
        selectionContainer="py-[10px]"
      ></Select>
    </div>
  </div>
</template>

<style></style>
